// tiktok-landing.js — TikTok LP page-level UI (scroll reveal, header, sticky bar, video)
// Bundle logic lives in bundle-builder.js; cart logic lives in light-cart-drawer.js.
(function () {

  /* ---- Scroll reveal ---- */
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    els.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => { el.style.opacity = '1'; el.style.transform = 'none'; });
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'none';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => io.observe(el));
  }

  /* ---- Header scroll ---- */
  function initHeader() {
    const hdr = document.querySelector('.hdr');
    if (!hdr) return;
    window.addEventListener('scroll', () => {
      hdr.classList.toggle('is-solid', window.scrollY > 24);
    }, { passive: true });
  }

  /* ---- Sticky bar ---- */
  function initStickyBar() {
    const bar = document.getElementById('tl-stickybar');
    if (!bar) return;
    window.addEventListener('scroll', () => {
      bar.classList.toggle('is-show', window.scrollY > window.innerHeight * 0.7);
    }, { passive: true });
    document.getElementById('tl-sticky-btn')?.addEventListener('click', () => {
      const el = document.getElementById('tl-bundle');
      if (el) window.scrollTo({ top: el.offsetTop - 60, behavior: 'smooth' });
    });
  }

  /* ---- Video player ---- */
  function initVideo() {
    const screen  = document.getElementById('tl-phone-screen');
    const video   = document.getElementById('tl-vp-video');
    const fill    = document.getElementById('tl-vp-fill');
    const overlay = document.getElementById('tl-play-overlay');
    const muteBtn = document.getElementById('tl-vp-mute');
    if (!video) return;

    video.addEventListener('timeupdate', () => {
      if (video.duration && fill) fill.style.width = (video.currentTime / video.duration * 100) + '%';
    });
    screen.addEventListener('click', () => {
      if (video.paused) { video.play(); if (overlay) overlay.hidden = true; }
      else              { video.pause(); if (overlay) overlay.hidden = false; }
    });
    if (muteBtn) {
      muteBtn.addEventListener('click', e => {
        e.stopPropagation();
        video.muted = !video.muted;
      });
    }
  }

  /* ---- Init ---- */
  function init() {
    initReveal();
    initHeader();
    initStickyBar();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
